import { useContext } from 'react'

import ActivityModalContext from 'contexts/ActivityModalContext'

const useActivityModal = () => {
  const context = useContext(ActivityModalContext)

  if (context === undefined) {
    throw new Error(
      'useActivityModal must be used within an ActivityModalProvider',
    )
  }

  return context
}

export default useActivityModal
